import React, {Component} from "react";
import {Box, Button, TextField, Theme, Typography, Grid } from '@material-ui/core/';
import {withStyles} from '@material-ui/core/styles'
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import ValidateForm from "../../../../helper/validations";
import * as actions from "../../../../store/actions";
import {Auth, Hub} from "aws-amplify";
import CircularProgress from '@material-ui/core/CircularProgress';
import {checkUserAuth} from "./checkUserAuth";
import {CognitoHostedUIIdentityProvider} from "@aws-amplify/auth";
import {Styles} from "@material-ui/styles";
import Messages from "../../../../helper/messages";
import Backdrop from "@material-ui/core/Backdrop/Backdrop";
import Alert from '@material-ui/lab/Alert';
import ReactHtmlParser, {processNodes} from "react-html-parser"
import {Helmet} from "react-helmet";
import apiConfigs from "../../../../config/config";
import clsx from 'clsx';
import Config from "../../../../config/config";
import UtilService from '../../../../helper/service';
import * as ImmersionGQL from "../../../../gql";
import { isFreeEmailDomain } from "../check_free_email_domains";
import CustomSnackBar from '../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';

const CssTextField = withStyles({
  root: {
    '& label': {
      fontSize: 14,
      color: '#19191e'
    },
    "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
      color: "#6667AB"
    }
  },
})(TextField);

const useStyles: Styles<Theme, any, any> = () => ({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  
  label: {
    color: '#19191e',
    "&$focusedLabel": {
      color: "#6667AB"
    },
    "&$erroredLabel": {
      color: "#6667AB"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#19191e',
    "&$error:after": {
      borderBottomColor: "#6667AB"
    },
    "&:after": {
      borderBottom: `2px solid #6667AB`
    }
  },

  mt30: {
    marginTop: 30,
    marginBottom: 30,
  },

  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"90%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"90%",
      maxWidth: "374px",
    },
  },
  
  textCenter: {
    textAlign: 'center',
    color: '#19191e'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#6667AB'
  },
  smallText: {
    color: '#19191e'
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    color: '#6667AB',
    border: '1px solid rgba(102, 103, 171, 0.5)',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    '&:hover': {
			border: '1px solid #6667AB',
      backgroundColor: 'rgba(102, 103, 171, 0.2)'
		},
  },
  loginForm: {
    paddingTop: '20'
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  //for page 1
  registerLogo:{
    width:"280px",
    height:"41px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description:{
    textAlign:"center",
    font: "normal normal bold 36px/26px Spartan-bold",
    color: "#19191e",
    opacity: "1"
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#F2F2FA',
    width: '100vw',

    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },

  //-----for page 2
  registerlogo2container:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      marginTop:"20px",
      textAlign:"center", 
      width:"100%"
    },
  },
  registerLogo2:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  description2:{
    textAlign:"center",
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#19191e",
    opacity: "1",
    marginBottom: "10px"
  },
  layout2: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop:"20px",
    display: 'flex',
    justifyContent: 'center',
    textAlign:"center",
    alignItems: 'center',
    height: '100vh',
    background: '#F2F2FA',
    width: '100vw',
  
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  description_smart:{
    textAlign:"center",
    font: "normal normal bold 24px/26px Spartan-bold",
    color: "#6667ab",
  },
  error: {}
});

interface IProps {
  registerUser: (client: any, requestData: any, history: any, match: any) => void,
  apolloClient: any,
  history: any,
  classes: any;
  authUser: any;
  notification: any;
  match: any;
}

interface IState {
  email: string,
  // fname: string,
  // lname: string,
  loading: boolean,
  googleLoading: boolean,
  appleLoading: boolean,
  errors: any,
  user: any,
  customState: any,
  disable: boolean;
  errorMsg: string;
  [key: string]: any,
  isOpenSignupwithEmail:boolean,
  planName: string,
  snackAlertType:string,
  snackAlertMsg:string,
  isShownSnackAlert:boolean
}

class Begin extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      email: "",
      // fname: "",
      // lname: "",
      errorMsg: "",
      loading: false,
      googleLoading: false,
      appleLoading: false,
      errors: {
        email: "",
      },
      snackAlertType:"success",
      snackAlertMsg:"",
      isShownSnackAlert:false,
      disable: true,
      user: {},
      customState: {},
      isOpenSignupwithEmail: true,
      isRscUrl:false,
      rscText:"",
      planName: this.props.match.params.plan ? this.props.match.params.plan.toLowerCase() : "free",
    };
  }

  hideSnackAlert = () => {
    this.setState({
      isShownSnackAlert:false
    })
  }

  /* Load init actions */
  componentDidMount() {
    Hub.listen("auth", ({payload: {event, data}}) => {
      switch (event) {
        case "signIn":
          this.setState({user: data});
          break;
        case "signOut":
          this.setState({user: null});
          break;
        case "customOAuthState":
          this.setState({ customState: data });
          if(data && typeof(data) === "string" && data !==""){
            this.setState({ rscText: data });
          }
          break;
        default:
          break;
      }
    });

    //const plan = this.props.match.params.plan ? this.props.match.params.plan.toLowerCase() : "free";
    //console.log("Requested plan is: " + this.state.planName);

    
    


    // check user authentication
    checkUserAuth(this)
    const queryStringRsc = new URLSearchParams(this.props.history.location.search).get("rsc")
    if(queryStringRsc){
      this.setState({
        isRscUrl:true,
        rscText:queryStringRsc,
        rscRoute:"/user/login?rsc="+queryStringRsc,
      })
    }
  }

  /* when receive data from reducer */
  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      if (props.notification.message && !props.notification.success) {
        this.setState({
          errorMsg: props.notification.message,
        })
      }
      this.setState({
        loading: false,
        googleLoading: false,
        appleLoading: false,
        disable: true
      });
    }
    // don't show the alert when back to this page.
    if (!this.state.email && localStorage.getItem('sso_login') === "false") {
      this.setState({ errorMsg: "" })
    }
  }

  
  

  buildStripeCheckout = async (email: string) => {
    
    let priceId = Config.billing.planLowPriceId;
    let usagePriceId = Config.billing.planLowUsagePriceId;

    if (this.state.planName === Config.billing.planMedium) {
        priceId = Config.billing.planMediumPriceId;
        usagePriceId = Config.billing.planMediumUsagePriceId;
    } else if (this.state.planName === Config.billing.planHigh) {
        priceId = Config.billing.planHighPriceId;    
        usagePriceId = Config.billing.planHighUsagePriceId;    
    }
  

    this.props.apolloClient.client.query({
      query: ImmersionGQL.getStripeCheckoutSession,
      fetchPolicy: "no-cache",
      variables: {
        email: email,
        priceid: priceId,
        usagepriceid: usagePriceId,
        domain: "lively",
        success: Config.billing.success_url,
        failure: Config.billing.failure_url,
      }
    })
    .then((response: any) => {
      console.log(response.data.getStripeCheckoutSession.data);
      if (response.data.getStripeCheckoutSession.data.url) {
        window.location.href = response.data.getStripeCheckoutSession.data.url;
      }
    });


  }

  isAlreadyRegistered = async (email: string) => {
    let result = false;
    this.props.apolloClient.client.query({
      query: ImmersionGQL.queryCheckEmail,
      fetchPolicy: "no-cache",
      variables: {
        email: email.toLowerCase().trim(),
      }
    })
      .then((mailResponse: any) => {
        if (mailResponse.data.checkEmail.status === "true") {
          //console.log("isAlreadyRegistered is false");
          result = false;
          this.setState({ disable: false });
        } else {
          //console.log("isAlreadyRegistered is true");
          result = true;
          const errors: any = {};
          errors.email = Messages.TENANT.ERROR.EMAIL.INVALID_REGISTERED;
          this.setState({
            snackAlertType:"error",
            snackAlertMsg: Messages.TENANT.ERROR.EMAIL.INVALID_REGISTERED,
            isShownSnackAlert:true
           });
           this.setState({ disable: true });


        }
      });
      return result;
  }


  // sign up with google
  googleSignUp = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ googleLoading: true });
    await Auth.federatedSignIn({provider: CognitoHostedUIIdentityProvider.Google,customState:this.state.rscText});
  };

  // sign up with apple
  appleSignUp = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ appleLoading: true });
    await Auth.federatedSignIn({provider: CognitoHostedUIIdentityProvider.Apple,customState:this.state.rscText});
  };

  // sign up with email address
  openSignupEmail = async () => {
    this.setState({ isOpenSignupwithEmail: true });
  };
  handleSubmit = () =>{

  }

  // register new user
  onUserRegister = async (e: any) => {
    e.preventDefault()

    


    const requestData = {
      email: this.state.email,
      rsc: this.state.rscText?this.state.rscText:"",
    };
    const validateError = ValidateForm.validateRegisterForm(requestData);
    this.setState({ errorMsg: "" });
    localStorage.setItem('sso_login', String(false));
    
    //const alreadyReg = await this.isAlreadyRegistered(this.state.email);
    //console.log(alreadyReg);

    if (!Object.keys(validateError).length) {
      this.setState({errors: {}})
      this.setState({loading: true});

      this.buildStripeCheckout(this.state.email);
 //     this.props.registerUser(this.props.apolloClient.client, requestData, this.props.history, this.props.match);
    } else {
      this.setState({errors: validateError})
    }
  };

  // when change any field
  validateRegisterForm = (event: any) => {
    const input = event.target.name;
    const value = (event.target.value).trim();

    const errors: any = {};
    const validEmail = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    switch(input) {
      case "email":
        // if (!value) {
        //   errors.email = Messages.TENANT.ERROR.EMAIL.EMPTY;
        // } else 
        
        if (value && !validEmail.test(value)) {
          errors.email = Messages.TENANT.ERROR.EMAIL.INVALID;
        } else if (isFreeEmailDomain(value)) {
          errors.email = Messages.TENANT.ERROR.EMAIL.INVALID_FREE;
        } else {
          //console.log("check reg");

          this.isAlreadyRegistered(value).then((resp: any) => {
            if (resp) {
              errors.email = Messages.TENANT.ERROR.EMAIL.INVALID_REGISTERED;
            }
          });

        }
        
        //console.log(errors.email);

        break;
      // case "fname":
      //   if (!value) {
      //     errors.fname = Messages.TENANT.ERROR.FIRST_NAME.EMPTY;
      //   } else if (!regex.test(value)) {
      //     errors.fname = Messages.TENANT.ERROR.FIRST_NAME.INVALID;
      //   }
      //   break;
      // case "lname":
      //   if (!value) {
      //     errors.lname = Messages.TENANT.ERROR.LAST_NAME.EMPTY;
      //   } else if (!regex.test(value)) {
      //     errors.lname = Messages.TENANT.ERROR.LAST_NAME.INVALID;
      //   }
      //   break;
    }
    this.setState({
      errors: {
        ...this.state.errors,
        [input]: errors[input]
      },
      [input]: value
    }, () => {
      const { errors } = this.state;
      // if (!errors.email && !errors.fname && !errors.lname) {
      if (!errors.email && value) {
        this.setState({ disable: false });
      } else {
        this.setState({ disable: true });
      }
    });
  };

  transform = (node: any, index: any) => {
    if (node.type === "tag" && node.name === "span") {
      return (
        <span style={{ cursor: "pointer" }} key={index}>
          { processNodes(node.children, this.transform) }
        </span>
      );
    }
  }

  render() {
    const {classes, authUser} = this.props;
    const {
      errors,
      loading,
      googleLoading,
      appleLoading,
      disable,
      errorMsg,
      isOpenSignupwithEmail,
      planName
    } = this.state;
    
    const options = {
      decodeEntities: true,
      transform: this.transform
    };
    return (
      <React.Fragment>
        <Helmet title="Sign Up"/>
        {isOpenSignupwithEmail ?
          <>
            
            <div className={classes.layout2}>
            <Grid container spacing={3}>

            <Grid item xs={12} sm={6}  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src="/assets/images/lively/meeting_02.png" />
              </Grid>

              <Grid item xs={12} sm={6} >
              <Box className={classes.mainDiv}>
                <div className="login-form">

                <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>{UtilService.capitalizeFirstLetter(planName)}!</Typography>
                <Typography variant="h6" component="h6" className={clsx(classes.textCenter, classes.headline)}>Brilliant, this is a great place to start.  Remember, all participant measurements for people that belong to your email domain are free. That&#39;s why we ask for your work email address to sign up.</Typography>
                 
                  <form noValidate onSubmit={this.onUserRegister}>
                  <CssTextField
                     value={this.state.email.trim()}
                     className="required-text"
                     InputLabelProps={{
                       classes: {
                         root: classes.label,
                         focused: classes.focusedLabel,
                         error: classes.erroredLabel
                       },
                     }}
                     InputProps={{
                       classes: {
                         root: classes.underline,
                         error: classes.error
                       }
                     }}
                     margin="normal"
                     style={{ width: '100%', font: "normal normal bold 12px/14px Roboto" }}
                     id="email"
                     label={"Enter Email Address "}
                     name="email"
                     autoComplete="email"
                     onChange={this.validateRegisterForm}
                      required={true}
                      helperText={(errors && errors.email) && (
                        <span style={{ color:"#fdca42"}}>{errors.email}</span>
                      )}
                    />
                    
                    { errorMsg && <Alert style={{width:"100%"}} icon={false} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
                    <Button
                      type="submit"
                      variant="outlined"
                      color="secondary"
                      className={clsx(classes.mt30, classes.actionButtons)}
                      
                      disabled={loading || disable}
                    >
                      {loading && <CircularProgress color="inherit" size={20}/>}
                      { !loading && <p style={disable ? { }: {}}>Let’s Get Started</p> }
                    </Button>
                  </form>
                  <p className="text-signin" style={{ marginBottom: 30 , marginTop:6, color:"#19191e"}}>By signing up, I agree to the <Link style={{color: '#19191e', textDecoration: 'underline'}} target="_blank" to={{ pathname:`${apiConfigs.KNOWN_PRIVACY_URL}`}}>Privacy Policy</Link> and <Link style={{color: '#19191e', textDecoration: 'underline'}} target="_blank" to={{pathname:`${apiConfigs.KNOWN_LEGAL_URL}`}}>Terms of Service.</Link></p>
                  {!this.state.isRscUrl &&
                    <p className="text-signin" style={{ color:"#19191e"}}>Already have an account? <Link style={{color: '#19191e', textDecoration: 'underline'}}  to="/user/login">Sign in</Link></p>
                  }
                  {this.state.isRscUrl &&
                    <p className="text-signin" style={{ color:"#19191e"}}>Already have an account? <Link style={{color: '#19191e', textDecoration: 'underline'}} to={this.state.rscRoute}>Sign in</Link></p>
                  }
                </div>
              </Box>
              </Grid>
              </Grid>
            </div>
          </>
        :
          <div className={classes.layout}>
            <Grid container spacing={3}>

            <Grid item xs={12} sm={6}  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src="/assets/images/lively/meeting_02.png" />
              </Grid>

              <Grid item xs={12} sm={6} >
            <Box className="">
            <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>What will you be <span className={classes.logoFont}>known</span> for?</Typography>
              

    
              <div className="login-form">
                <Button variant="outlined" color="secondary" type="button" size="large"
                        startIcon={ !googleLoading && <img src="/assets/images/google.svg" alt="{img}" className="social-icon"/> }
                        className={classes.actionButtons}
                        disabled={ googleLoading }
                        style={{marginTop: 30}}
                        onClick={() => this.googleSignUp()}>
                  {googleLoading && <CircularProgress color="inherit" size={20}/>}
                  { !googleLoading && <p>Continue with Google</p> }
                </Button>
                <Button type="button" variant="outlined" color="secondary" size="large"
                        startIcon={ !appleLoading && <img alt="{img}" src="/assets/images/apple.svg" className="social-icon"/> }
                        className={classes.actionButtons}
                        disabled={ appleLoading }
                        onClick={() => this.appleSignUp()}>
                  {appleLoading && <CircularProgress color="inherit" size={20}/>}
                  { !appleLoading && <p>Continue with Apple</p> }
                </Button>
                <Button
                  type="button" variant="outlined" color="secondary" size="large"
                  className={classes.actionButtons}
                  
                  onClick={this.openSignupEmail}
                >
                  <p style={{ color: '#19191e' }}>Sign up with email</p>
                </Button>
                <p className="text-signin" style={{ marginBottom: 30 , marginTop:6, color:"#19191e"}}>By signing up, I agree to the <Link style={{color: '#19191e', textDecoration: 'underline'}} target="_blank" to={{ pathname:`${apiConfigs.KNOWN_PRIVACY_URL}`}}>Privacy Policy</Link> and <Link  style={{color: '#19191e', textDecoration: 'underline'}} target="_blank" to={{pathname:`${apiConfigs.KNOWN_LEGAL_URL}`}}>Terms of Service.</Link></p>
                {!this.state.isRscUrl &&
                  <p className="text-signin" style={{ color:"#19191e"}}>Already have an account? <Link style={{color: '#19191e', textDecoration: 'underline'}} to="/user/login">Sign in</Link></p>
                }
                {this.state.isRscUrl &&
                  <p className="text-signin" style={{ color:"#19191e"}}>Already have an account? <Link style={{color: '#19191e', textDecoration: 'underline'}} to={this.state.rscRoute}>Sign in</Link></p>
                }
              </div>
            </Box>

            <div className="loader">
              <Backdrop open={ authUser.screen_loading } >
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>
            </Grid>
            </Grid>
          </div>
        }
        <CustomSnackBar type={this.state.snackAlertType} message={this.state.snackAlertMsg} open={this.state.isShownSnackAlert} onClose={this.hideSnackAlert} />
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    registerUser: (client: any, request: any, history: any) => {
      dispatch(actions.registerUser(client, request, history));
    },
    logoutUserSuccess: (user: any) => {
      dispatch(actions.logoutUserSuccess(user));
    },
    onLogout: () => { 
      dispatch(actions.onLogout());
    },
  };
};

const WondrBeginComponent = withStyles(useStyles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(Begin));

export {
  WondrBeginComponent
}
